/*
 * jQuery special events for delayedEnter, delayedLeave, and delayedHover
 * Author: Scott Jehl, scott@filamentgroup.com
 * Copyright (c) 2011 Filament Group
 * licensed under MIT
 * note: Each event can be used with bind or live event handling as you would use mouseenter,mouseleave, and hover
 * events fire after 200ms timeout
 */
(function ($) {
    //delayedEnter event

    $.map('delayedEnter delayedLeave'.split(' '), function (eventname) {

        $.event.special[eventname] = {
            enabled: true,

            setup: function (data) {
                var thisObject = this,
                    $this = $(thisObject),
                    hovering,
                    timer;

                var timeout = data.timeout ? data.timeout : 200;

                function trigger(event) {
                    var originalType = event.type;
                    event.type = eventname;

                    // Use dispatch instead of handle since 1.9
                    $.event.dispatch.call(thisObject, event);
                    event.type = originalType;
                }
                function func1(event) {
                    if (!$.event.special[eventname].enabled) {
                        return;
                    }
                    hovering = true;

                    clearTimeout(timer);

                    timer = setTimeout(function () {
                        if (hovering) {
                            trigger(event);
                        }
                    }, timeout);
                }
                function func2(event) {
                    hovering = false;
                }
                $this.bind({
                    "mouseenter": (eventname === "delayedEnter" ? func1 : func2),
                    "mouseleave": (eventname === "delayedEnter" ? func2 : func1)
                }, data);
            },
            // .off() hook
            remove: function () {
                $(this).off('mouseleave mouseenter');
            }
        };

        //make available as method
        $.fn[eventname] = function (fn, options) {
            var settings = $.extend({
                timeout: 200
            }, options);
            //$.fn[eventname].settings = settings;
            return fn ? this.bind(eventname, settings, fn) : this.trigger(eventname, options);
        };

        // Internal attr "attrFn" was removed since 1.9.0
        // http://jquery.com/upgrade-guide/1.9/#removed-properties-of-the-event-object
        // read comments here: https://github.com/jquery/jquery-mobile/pull/4759
        if ($.attrFn) {
            $.attrFn[eventname] = true;
        }

    });

    //proxy similar to jQuery's hover
    //if leaveCallback isn't defined, enterCallback will apply to both
    $.fn.delayedHover = function (enterCallback, leaveCallback, options) {
        return this.delayedEnter(enterCallback, options).delayedLeave(leaveCallback || enterCallback, options);
    };

    // $.fn.delayedEnter = function( fn, options ){
    //     return this.delayedEnter(fn, options);
    // };

    // $.fn.delayedLeave = function( fn, options ){
    //     return this.delayedLeave(fn, options);
    // };

})(jQuery || window.$);
